import Vue from 'vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    name: 'dropdown-select',
    data () {
        return {
            open: false,
            scroll: false,
            container: document.body
        }
    },
    props: {
        list: {
            type: Array,
            default: []
        },
        value: {
            default: null,
        },
        placeholder: String,
        name: String,
        max: {
            type: Number,
            default: 8,
        },
        type: {
            type: String,
        }
    },
    computed: {
        selected() {
            return this.list.find(item => {
                return item.value == this.value
            })
        }
    },
    methods: {
        select(item) {
            this.open = false
            this.$emit('update:value', item.value)
            this.$emit('change', item.value)
            this.$emit('input', item.value)
            this.$emit('blur')
        },
        openDropdown() {
            let option = this.$refs.scroll.$el.getElementsByClassName('first')[0]
            let content = this.$refs.options
            let wrap = this.$refs.wrap

            if (option && content) {
                this.$nextTick(() => {
                    let itemHeight = option.clientHeight + this.getStyleValue(option, 'marginBottom') + this.getStyleValue(option, 'marginTop')
                    let maxHeight = itemHeight * this.max + this.getStyleValue(wrap, 'paddingBottom') + this.getStyleValue(wrap, 'paddingTop')
                    let height =  this.list.length * itemHeight
                    this.scroll = height > maxHeight

                    content.style.height = this.scroll ? maxHeight + 'px' : 'auto'

                    this.$refs.scroll.update()
                    this.$emit('select:open')
                })
            }
        },
        getStyleValue(el, style) {
            return parseInt(window.getComputedStyle(el)[style])
        }

    },
    components: {
        Dropdown,
        VuePerfectScrollbar,
    }
}


// WEBPACK FOOTER //
// ./src/components/dropdownSelect/dropdownSelect.js